import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { InsideService } from '../../services/inside.service';
import { ListForm } from '../../../../base/controlers/list-form';
import { Item } from '../../models/item';
import { ItemService } from '../../services/item-service.service';
import { PagedListForm } from '../../../../base/controlers/paged-list-form';
import { fromEvent } from 'rxjs';
import { debounceTime, distinctUntilChanged, filter, tap } from 'rxjs/operators';

@Component({
  selector: 'app-item-list',
  templateUrl: './item-list.component.html',
  styleUrls: ['./item-list.component.css']
})
export class ItemListComponent extends PagedListForm<Item> implements OnInit, AfterViewInit {
  public displayedColumns = ['actions','code','name'];
  @ViewChild('search',{static:true}) search: ElementRef;
  constructor(
    protected itemService: ItemService,
    protected router:Router        
  ) {
    super(itemService,'/plasard-measurement/item',router,null,'code');
   }

  ngOnInit() {
    super.ngOnInit();
  }  
  ngAfterViewInit() {
    // server-side search
    fromEvent(this.search.nativeElement,'keyup')
        .pipe(
            filter(Boolean),
            debounceTime(300),
            distinctUntilChanged(),
            tap((_) => {
              const filter = this.search.nativeElement.value.trim();
              let query = null;
              if(filter){
                query = `contains(code, '${filter}') or contains(name, '${filter}')`;
              }
              this.onFilter(query);
            })
        )
        .subscribe();
    }
}
